/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectItemsDropdownComponent } from './select-items-dropdown/select-items-dropdown.component';
import { SelectModule, Select } from 'primeng/select';
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {AddEmptySelectItemVoOptionPipe} from "./add-empty-select-item-vo-option.pipe";
import {AddAllSelectItemOptionPipe} from "./add-all-select-item-option.pipe";
import { TranslateSelectItemPipe } from './translate-select-item.pipe';
import { FloatLabel } from 'primeng/floatlabel';

@NgModule({
  imports: [CommonModule, SelectModule, FormsModule, TranslateModule, FloatLabel,
    Select],
  declarations: [SelectItemsDropdownComponent, AddEmptySelectItemVoOptionPipe, AddAllSelectItemOptionPipe, TranslateSelectItemPipe],
  exports: [SelectItemsDropdownComponent, TranslateSelectItemPipe, AddEmptySelectItemVoOptionPipe]
})
export class SelectItemsModule {

}
